<template>
    <v-dialog :value="visible" max-width="440" :persistent="carregando" @input="$emit('close')">
        <v-card>
            <v-toolbar dark dense flat :color="cor">
                <v-toolbar-title class="white--text">{{ titulo }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="pt-4">
                <div v-if="texto" class="mb-4">{{ texto }}</div>
                <v-textarea
                    v-model="valor"
                    :label="label"
                    :rules="obrigatorio ? [v => !!(v && v.trim()) || 'Obrigatório'] : []"
                    outlined
                    auto-grow
                    rows="2"
                    counter="255"
                    maxlength="255"
                />
            </v-card-text>

            <v-card-actions>
                <v-btn text :disabled="carregando" @click="$emit('close')">Voltar</v-btn>
                <v-spacer/>
                <v-btn
                    :color="cor"
                    dark
                    depressed
                    :loading="carregando"
                    :disabled="obrigatorio && !(valor && valor.trim())"
                    @click="$emit('confirmar', (valor || '').trim())"
                >
                    {{ botao }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'MotivoDialog',

    props: {
        visible: { type: Boolean, default: false },
        titulo: { type: String, default: '' },
        texto: { type: String, default: '' },
        label: { type: String, default: 'Motivo' },
        botao: { type: String, default: 'Confirmar' },
        cor: { type: String, default: 'primary' },
        obrigatorio: { type: Boolean, default: true },
        carregando: { type: Boolean, default: false },
    },

    data: () => ({
        valor: '',
    }),

    watch: {
        visible(aberto) {
            if (aberto) this.valor = '';
        },
    },
};
</script>
